import {
	DatePicker as BaseDatePicker,
	type CalendarDate,
	type DatePickerProps,
} from "@heroui/react";
import { Icon } from "@iconify/react";
import type { CalendarDateTime } from "@internationalized/date";

import { useFieldContext, useLanguage } from "@onesolution/hooks";
import type { ZonedDateTime } from "node_modules/@heroui/system/dist/types";

export function DatePicker(props: DatePickerProps) {
	const field = useFieldContext<
		CalendarDate | CalendarDateTime | ZonedDateTime | null
	>();
	const { t } = useLanguage();

	return (
		<BaseDatePicker
			labelPlacement="outside"
			startContent={
				field.state.value ? (
					<Icon
						className="cursor-pointer min-w-4 text-foreground"
						icon="solar:close-circle-line-duotone"
						width={24}
						height={24}
						onClick={() => field.handleChange(null)}
					/>
				) : null
			}
			aria-label="date picker"
			id={field.name}
			isInvalid={!field.state.meta.isValid}
			name={field.name}
			value={field.state.value as unknown as undefined}
			onBlur={field.handleBlur}
			errorMessage={t("message.required")}
			onChange={(v) => v && field.handleChange(v)}
			{...props}
		/>
	);
}
